<template>
  EditorAnswer
</template>

<script>
export default {
  name: "EditorAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
  },
};
</script>
